import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

export default function SelectOptionGroupNameInput(props) {
  const { value, setValue, placeholder, index, isModify } = props;

  const [width, setWidth] = useState(92);

  const SpanRef = useRef();

  // 인풋 크기 정리
  useEffect(() => {
    if (SpanRef.current) setWidth(SpanRef.current.offsetWidth + 4);
  }, [value])

  function handleChange(e) {
    setValue(e.target.value, index);
  }

  function handleFocus(e) {
  }

  function handleBlur(e) {
  }

  return (
    <InputView>
      <HiddenSpan ref={SpanRef}>{value || placeholder}</HiddenSpan>
      <Input
        placeholder={placeholder}
        value={value}
        type='text'
        width={width}
        disabled={!isModify}
        // disabled={false}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  // width: calc(31.74% - 4px);
  // width: ${props => props.width}px;
  height: 28px;

  border: 2px dashed #909090;
  border-radius: 5px;
  background-color: #444447;
`;

const HiddenSpan = styled.span`
  position: absolute;

  visibility: hidden;
  white-space: pre;

  font-family: NotoSansKR-Bold;
  font-size: 14px;
  line-height: 18px;

  padding: 0;
  margin: 0;
`;

const Input = styled.input`
	font-family: NotoSansKR-Medium;
	font-size: 14px;
	line-height: 17px;

	// width: 100%;
  width: ${props => props.width}px;
	height: 17px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
	color: #FFFFFF;

  text-align: center;

  border: none;
  background-color: #444447;

	::placeholder {
		color: #6A6A6C;
	}
  
  // transition: all 0.3s ease-in-out;
`;